import { stringify } from 'qs'

import { getCurrentBearerToken } from '@sparkai/auth'
import { createHttpClient } from '@sparkai/utils'

import { getSelectedTimezoneContextHeaders } from './timezoneRequestContext'

class TokenStore {
  private value: string | undefined

  get() {
    return this.value
  }

  set(value: string) {
    this.value = value
  }
}

export const tokenStore = new TokenStore()

const baseURL = `${window.location.origin.toString()}/`

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const paramsSerializer = (params: any) => {
  return stringify(params, { arrayFormat: 'indices' })
}

export const apiClient = createHttpClient({
  baseURL,
  headers: defaultHeaders,
  timeout: 15000,
  paramsSerializer,
  prepareHeaders: (headers) => {
    const token = tokenStore.get() ?? getCurrentBearerToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }

    Object.entries(getSelectedTimezoneContextHeaders()).forEach(([key, value]) => {
      if (!headers.has(key)) headers.set(key, value)
    })
  },
})
